/**
 * Created by lg on 18/5/22.
 */
import Vue from 'vue'
var NormalHelper = {};

// 获取
export function getClientToken(){
    return Date.parse(new Date());
}

// 工单页
export function goWorkPage(){
    window.open(Vue.prototype.Config.WORK_URL,'_blank');
}

//登录页
export function goLoginPage(){
    window.location.href = Vue.prototype.Config.LOGIN_URL +'?returnUrl=' + Vue.prototype.Config.RETURN_URL;
}

//列表页
export function goListPage(){
  window.location.href = Vue.prototype.Config.RETURN_URL;
}

//订单管理页
export function goOrderPage(){
  window.location.href = 'https://uc.jdcloud.com/cost/order';
}


//解析url参数
export function parseUrlQuery(p_url) {
    var query = {},
        i, params, param;
    if (p_url.indexOf('?') >= 0) p_url = p_url.split('?')[1];
    else return query;
    params = p_url.split('&');
    for (i = 0; i < params.length; i++) {
        param = params[i].split('=');
        query[param[0]] = param[1];
    }
    return query;
};


//获取cookie
export function getCookie(name=null) {
    var strCookie = document.cookie;
    if (name) {
        var arrCookie = strCookie.split("; ");
        for(var i = 0; i < arrCookie.length; i++){
            var arr = arrCookie[i].split("=");
            // alert(arr[0] +":"+ arr[1]);
            if(name == arr[0]){
                return arr[1];
            }
        }
    }else{
        return strCookie;
    }
};
export function setCookie(name, value, expiresTime) {
    var cdata = name + "=" + escape(value);
    if (expiresTime > 0) {
        var Days = expiresTime;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        cdata += "; expires=" + exp.toGMTString();
    }
    cdata += "; path=/";
    document.cookie = cdata;
};
export function delCookie(name) {
    this.setCookie(name, null, -1);
};




//是否为数组
export function isArray(obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
};

// 去重
export function unique(arr) {
    var unique = {};
    arr.forEach(function(arr) {
        unique[JSON.stringify(arr)] = arr;
    });
    arr = Object.keys(unique).map(function(u) {
        return JSON.parse(u);
    });
    return arr;
};

export default NormalHelper;



// WEBPACK FOOTER //
// ./src/common/NormalHelper.js